const urls = {
  fetchConsignerVehicles: (payload: Array<string>) => {
    return `/vehicle/getConsignerVehicles?${payload.join('&')}`;
  },
  fetchFilters: () => {
    return `/vehicle/getFilters`;
  },
  fetchItineraryData: (payload: number) => {
    return `/vehicle/getItinerary?vehicleId=${payload}`;
  },
  fetchPathDetails: (payload: number) => {
    return `/vehicle/getPathDetail?vehicleId=${payload}`;
  },
  fetchCurrentLocation: (payload: number) => {
    return `/vehicle/getCurrentLocation?vehicleId=${payload}`;
  },
  downloadReport: (payload: Array<string>) => {
    return `/data/getVehicleByOperatorReport?${payload.join('&')}`;
  },
};

export default urls;
